
import appError from '#shared/util/appError.js';
import readArguments from '#shared/util/readArguments.js';

import asyncCall from './asyncCall.js';

/**
 * Open the URL in default browser window
 * @param {string} url
 * @returns {Promise}
 */
export default function openInBrowser(url) {
	if (typeof url === 'string' && url.length) {
		return new Promise((resolve) => {
			const timeout = setTimeout(() => {
				if (typeof window.AvCommand === 'function') { // fallback for legacy client
					window.AvCommand(`shell_exec:open:${url}`); // eslint-disable-line new-cap
				} else { // fallback for browser
					window.open(url, '_blank');
				}
			}, 1000);
			asyncCall('OpenUrl', ([, error]) => { // call for modern client
				if (!error) {
					clearTimeout(timeout);
					resolve({});
				}
			}, {
				url
			});
		});
	} else {
		throw appError('Invalid method arguments to openInBrowser', {
			code: 'APP_FRONTEND_UTIL',
			origin: 'openInBrowser',
			detail: readArguments(arguments) // @todo update detail structure
		});
	}
}
